import Script from 'next/script'

export default function GoogleAnalyticsScript({
  GA_TRACKING_ID,
  onlyContent = false,
}) {
  const content = (
    <>
      {/* Refer https://developers.google.com/tag-platform/tag-manager */}
      {/* Google Tag */}
      <Script
        strategy="afterInteractive"
        src={`https://www.googletagmanager.com/gtag/js?id=${GA_TRACKING_ID}`}
      ></Script>
      <Script
        strategy="afterInteractive"
        defer
        dangerouslySetInnerHTML={{
          __html: `
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());

          gtag("config", '${GA_TRACKING_ID}', {page_path: window.location.pathname});
          `,
        }}
      ></Script>
      {/* End Google Tag Manager */}
    </>
  );

  return onlyContent ? content : <>{content}</>;
}
